import { HttpClient, HttpContext, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { SHOW_GLOBAL_LOADER } from '@shared/data-access/data-access-ui';
import { isDefined } from '@shared/utils/is-defined.utils';
import { Observable } from 'rxjs';
import { FilterLogRequest } from '../model/log-filter-request.model';
import { Log } from '../model/log.model';

@Injectable({
  providedIn: 'root',
})
export class LogService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = environment.apiUrl;

  getLogs(payload: FilterLogRequest): Observable<Log[] | []> {
    let params = new HttpParams();

    if (payload.search) {
      params = params.set('search', payload.search);
    }

    if (isDefined(payload.pageNumber)) {
      params = params.set('pageNumber', payload.pageNumber);
    }

    if (payload.pageSize) {
      params = params.set('pageSize', payload.pageSize);
    }

    return this.http.get<Log[] | []>(`${this.baseUrl}/v1/activitylogs`, {
      params,
      context: new HttpContext().set(SHOW_GLOBAL_LOADER, payload.enableGlobalLoader),
    });
  }
}
